import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  GetZoomLink,
  ReportMissedCall,
  ZoomStatusUpdate,
} from "../../../../components/Header/Data2";
import { missedCallSMS, sendMessage } from "../../../../components/Header/Data";
import CustomerAvaliableCalander from "../../../../components/Header/CustomerAvaliableCalander";
import moment from "moment";
import {
  addIncomingMessage,
  setOppertunity,
  setOppertunityStage,
  setSelectedConversation,
  updateSelectedConvoFields,
} from "../../../../redux/slices/MsgSlice";
import { useSocket } from "../../../../contexts/SocketContext";
import {
  Dialog,
  DialogContent,
  Button,
  TextField,
  Typography,
  Box,
  IconButton,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CallDetailsModal = ({
  isOpen,
  closeModal,
  msg,
  reSchedule,
  setReSchedule,
  missedCall,
  setMissedCall,
}) => {
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const [reserveDate, setReserveDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [isCallDisabled, setIsCallDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [reserveDateTime, setReserveDateTime] = useState(null);
  const callHistory =
    msg && msg.zoomCallHistory && JSON.parse(msg?.zoomCallHistory);
  const participants = callHistory?.participants || [];
  const dateTime = `${msg?.reserveDate} ${msg?.startTime}`;
  const fomrmatedTime = moment(dateTime, "YYYY-MM-DD HH:mm")?.format(
    "MMMM D, YYYY [at] hh:mm A"
  );
  const logUser = user?.Role;
  const selectedConversation = useSelector(
    (state) => state.messages.selectedConvo
  );
  const { sendNewMessage } = useSocket();
  const dispatch = useDispatch();
  const providerZone = msg?.providerTimezone;
  const custZone = msg?.customerTimezone;

  const proTime = providerZone?.split(",")[0];
  const custTime = custZone?.split(",")[0];
  const proZone = providerZone?.split(",")[1];
  const custZoneName = custZone?.split(",")[1];

  const timeZoneFormat = (newDate, timeZone1, timeZone2) => {
    let protimelast, custtimelast;
    if (msg?.zoomRole === msg?.createdBy) {
      const protime = moment.tz(newDate, timeZone1);
      protimelast = protime.format("MMMM D, YYYY [at] hh:mm A");
      const custtime = moment.tz(protime, timeZone2);
      custtimelast = custtime.format("MMMM D, YYYY [at] hh:mm A");
    } else {
      const protime = moment.tz(newDate, timeZone2);
      protimelast = protime.format("MMMM D, YYYY [at] hh:mm A");
      const custtime = moment.tz(protime, timeZone1);
      custtimelast = custtime.format("MMMM D, YYYY [at] hh:mm A");
    }
    return { protimelast, custtimelast };
  };

  const response = timeZoneFormat(dateTime, proTime, custTime);
  const custDateTime = moment(
    response.custtimelast,
    "MMMM DD, YYYY [at] hh:mm A"
  );
  const custoDate = custDateTime.format("YYYY-MM-DD");
  const custoTime = custDateTime.format("HH:mm");
  const proDateTime = moment(
    response.protimelast,
    "MMMM DD, YYYY [at] hh:mm A"
  );
  const provDate = proDateTime.format("YYYY-MM-DD");
  const provTime = proDateTime.format("HH:mm");

  useEffect(() => {
    if (!msg) return;
    let reserveDateTime;
    if (msg?.zoomRole !== user?.UserID) {
      reserveDateTime = new Date(`${custoDate}T${custoTime}`);
    } else {
      reserveDateTime = new Date(`${provDate}T${provTime}`);
    }
    setReserveDateTime(reserveDateTime);
    const intervalId = setInterval(() => {
      const currentTime = new Date();
      const timeDiffInSeconds = (reserveDateTime - currentTime) / 1000;
      if (timeDiffInSeconds <= 5 * 60 && timeDiffInSeconds >= -15 * 60) {
        setIsCallDisabled(false);
      } else {
        setIsCallDisabled(true);
      }
    }, 1000);

    const currentTime = new Date();
    const timeDiffInSeconds = (reserveDateTime - currentTime) / 1000;
    if (timeDiffInSeconds <= 5 * 60 && timeDiffInSeconds >= -15 * 60) {
      setIsCallDisabled(false);
    } else {
      setIsCallDisabled(true);
    }

    return () => clearInterval(intervalId);
  }, [msg, custoDate, custoTime, provDate, provTime, user?.UserID]);

  const handleClick = () => {
    setMissedCall(true);
  };

  const ReportOther = async () => {
    if (isLoading) return;
    setIsLoading(true);
    const email =
      participants[0]?.user_email === msg.senderEmail
        ? msg.customerEmail
        : msg.senderEmail;
    await ReportMissedCall(email);
    closeModal();
    setIsLoading(false);
    toast.success(`Reported Other Party`);
  };

  const CallCancel = async () => {
    const formData = {
      updatedBy: user.UserID,
      zoomStatus: 7,
    };
    await ZoomStatusUpdate(formData, msg.Id);
    toast.info("Call Canceled");
    closeModal();
  };

  const CallLaunch = async (e) => {
    e.stopPropagation();
    if (msg.meetingLink) {
      window.open(msg.meetingLink, "_blank");
    } else {
      toast.error("Link is not available.");
    }
  };

  const ReSchedule = async () => {
    const currentDate = new Date().toISOString().split("T")[0];
    const currentTime = new Date();
    if (!reserveDate) {
      toast.error("Please enter date");
      return;
    }
    if (!startTime) {
      toast.error("Please enter time");
      return;
    }
    if (reserveDate < currentDate) {
      toast.error("Please do not enter a previous date");
      return;
    }

    const selectedDateTime = new Date(`${reserveDate}T${startTime}`);
    if (selectedDateTime < currentTime) {
      toast.error("Please do not enter a completed time");
      return;
    }
    const formData = {
      updatedBy: user.UserID,
      zoomStatus:
        msg?.createdBy === user?.UserID && logUser === "provider" ? 3 : 4,
      reserveDate: reserveDate,
      startTime: startTime,
      customerTimezone: custZone,
      providerTimezone: providerZone,
      zoomRole: user.UserID,
    };
    await ZoomStatusUpdate(formData, msg.Id);
    dispatch(
      updateSelectedConvoFields({
        zoomStatus: formData.zoomStatus,
        reserveDate: formData.reserveDate,
        startTime: formData.startTime,
        customerTimezone: formData.customerTimezone,
        providerTimezone: formData.providerTimezone,
        zoomRole: formData.zoomRole,
      })
    );
    if (msg?.createdBy === user?.UserID && logUser === "provider") {
      await AcceptZoomCall();
    }
    const updateForm = {
      customerId:
        selectedConversation.customerId === user.UserID
          ? selectedConversation.createdBy
          : selectedConversation.customerId,
    };
    sendNewMessage(updateForm);
    dispatch(addIncomingMessage(response.Data));
    closeModal();
    toast.success(`Reschedule Request Sent`);
  };

  const MessageRemainder = async () => {
    const customerId =
      msg?.ownerId === user?.UserID ? msg?.createdBy : msg.ownerId;
    const formData = {
      msgId: msg?.Id,
      postName: msg?.postName,
      meetingLink: msg?.meetingLink,
      customerName:
        msg?.createdBy === user?.UserID
          ? msg?.providerUserName
          : msg?.userName.split("@")[0].trim(),
    };
    await missedCallSMS(formData, customerId);
    closeModal();
    setIsLoading(false);
    toast.success("Remainder sent");
  };

  let parsedAvailability = [];
  if (msg && typeof msg?.availableFrom === "string") {
    try {
      parsedAvailability = JSON.parse(msg?.availableFrom);
    } catch (error) {
      console.error("Error parsing msg.availableFrom:", error);
      parsedAvailability = [];
    }
  }

  const convertTo12Hour = (time) => {
    if (typeof time !== "string") {
      return "";
    }
    const [hours, minutes] = time.split(":");
    const suffix = hours >= 12 ? "PM" : "AM";
    const adjustedHours = hours % 12 || 12;
    return `${adjustedHours}:${minutes} ${suffix}`;
  };

  const RejectZoomCall = async () => {
    setIsLoading(true);
    const formData = {
      updatedBy: user.UserID,
      zoomStatus: 2,
    };
    await ZoomStatusUpdate(formData, msg.Id);
    dispatch(
      updateSelectedConvoFields({
        zoomStatus: 2,
      })
    );
    toast.info("Call Rejected");
    closeModal();
    setIsLoading(false);
  };

  const isPastDateTime = (reserveDate, startTime) => {
    const reserveDateTime = new Date(`${reserveDate}T${startTime}`);
    const currentDateTime = new Date();
    return reserveDateTime < currentDateTime;
  };
  const isPast = isPastDateTime(msg?.reserveDate, msg?.startTime);

  const AcceptZoomCall = async () => {
    setIsLoading(true);
    const formattedStartTime = "2024-04-20T08:09:58.000Z";
    const formData = {
      startTime: formattedStartTime,
      customerName: msg?.userName.split("@")[0].trim(),
      vendorName: msg?.senderName,
      needName: msg?.postName,
    };
    try {
      const linkResponse = await GetZoomLink(formData, msg.Id);
      if (linkResponse && linkResponse.id && linkResponse.join_url) {
        const updateFormData = {
          updatedBy: user.UserID,
          zoomStatus: 3,
          meetingId: linkResponse.id,
          meetingLink: linkResponse.join_url,
          meetingStartLink: linkResponse.start_url,
          customerTimezone: custZone,
          providerTimezone: providerZone,
          reserveDate: reserveDate !== "" ? reserveDate : msg.reserveDate,
          startTime: startTime !== "" ? startTime : msg.startTime,
          needName: msg?.postName,
        };
        await ZoomStatusUpdate(updateFormData, msg.Id);
        dispatch(
          updateSelectedConvoFields({
            zoomStatus: 3,
            reserveDate: updateFormData.reserveDate,
            startTime: updateFormData.startTime,
            customerTimezone: updateFormData.customerTimezone,
            providerTimezone: updateFormData.providerTimezone,
            meetingId: updateFormData.meetingId,
            meetingLink: updateFormData.meetingLink,
            meetingStartLink: updateFormData.meetingStartLink,
          })
        );
        await handleSend(linkResponse.join_url);
      } else {
        toast.error("Error: Invalid response format or join_url not found");
      }
    } catch (error) {
      console.error("Error accepting Zoom call:", error);
      toast.error("An error occurred while accepting the Zoom call");
    }
    setIsLoading(false);
  };

  const handleSend = async (zoomLink) => {
    if (zoomLink.trim()) {
      const messageForm = {
        customerId:
          selectedConversation.customerId === user.UserID
            ? selectedConversation.createdBy
            : selectedConversation.customerId,
        postId: selectedConversation.postId,
        postType: 1,
        parentId:
          selectedConversation.parentId === 0
            ? selectedConversation.Id
            : selectedConversation.parentId,
        Description: `Call ${reSchedule ? "Rescheduled" : "Scheduled"} for ${
          reserveDate !== "" ? reserveDate : msg.reserveDate
        } at ${
          startTime !== "" ? startTime : msg.startTime
        } for 30 mins with ${zoomLink} `,
        messageStatus: 3,
        customerTimezone: custZone,
        providerTimezone: providerZone,
        createdBy: user.UserID,
        roleId: user.RoleId,
        ownerId: selectedConversation.ownerId,
        userName: user.UserName.split("@")[0].trim(),
        Email: user.Email,
        serviceNeed: "need",
        needName: selectedConversation.postName,
      };
      const response = await sendMessage(messageForm);
      if (response.Data) {
        let data = response.Data;
        if (data.parentId == 0) {
          dispatch(setSelectedConversation(data));
        }
        sendNewMessage(response.Data);
        dispatch(addIncomingMessage(response.Data));
        toast.success("Message Sent");
      }
    }
    closeModal();
    dispatch(setOppertunity(6));
    dispatch(setOppertunityStage(true));
  };
  const Warning = () => {
    return (
      <>
        {user.RoleId !== 1 && !isPast && !missedCall && (
          <Typography className="text-danger text-center my-2">
            <strong>
              Warning: Your communication score will be negatively affected if
              you reschedule.
            </strong>
          </Typography>
        )}
      </>
    );
  };
  return (
    <Dialog
      open={isOpen}
      onClose={closeModal}
      maxWidth="md"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "5px",
          padding: "10px",
          maxHeight: "80vh",
          overflowY: "auto",
          width: "50%",
          margin: "auto",
          border: "1px solid gray",
        },
      }}
    >
      <DialogContent className="p-0">
        <Box className="d-flex justify-content-end">
          <IconButton onClick={closeModal}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box className="p-2">
          {reSchedule ? (
            <Box>
              <Typography className="py-2">
                <strong>Note:</strong> All the scheduled calls are set to the
                default PST timezone. If necessary, please go to the Profile
                section to change the timezone
              </Typography>
              {msg?.ownerId === user.UserID ? (
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography className="mb-2">
                      Date <span className="text-red-500 font-bold">*</span>
                    </Typography>
                    <TextField
                      type="date"
                      fullWidth
                      onChange={(e) => setReserveDate(e.target.value)}
                      InputProps={{
                        inputProps: {
                          min: new Date().toISOString().split("T")[0],
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography className="mb-2">
                      From <span className="text-red-500 font-bold">*</span>
                    </Typography>
                    <TextField
                      type="time"
                      fullWidth
                      onChange={(e) => setStartTime(e.target.value)}
                      InputProps={{
                        inputProps: {
                          min: new Date().toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          }),
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              ) : (
                <>
                  <Typography className="text-sm font-semibold">
                    Please schedule the call using the tool below within the
                    Other Party mentioned availability schedule.
                  </Typography>
                  <CustomerAvaliableCalander
                    reserveDate={reserveDate}
                    startTime={startTime}
                    setReserveDate={setReserveDate}
                    setStartTime={setStartTime}
                    availableDays={parsedAvailability}
                    ownerId={msg.customerId}
                  />
                </>
              )}
              {startTime && (
                <Typography className="mt-2 text-sm">
                  The Calls will be scheduled for 30 min starting from{" "}
                  {convertTo12Hour(startTime)}
                </Typography>
              )}
              <Box className="d-flex justify-content-end mt-3 gap-2">
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => setReSchedule(false)}
                >
                  Go back
                </Button>
                <Button variant="contained" color="error" onClick={ReSchedule}>
                  Reschedule
                </Button>
              </Box>
              <Warning />
            </Box>
          ) : missedCall ? (
            <Box>
              <Typography variant="h5" className="text-center mb-4">
                Report Missed Call
              </Typography>
              <Typography className="mt-3 text-center">
                Utilize this feature to instantly send vendor a TEXT reminder to
                join meeting. Wait up to 5mins for vendor to join the scheduled
                meeting. If vendor does not "show" then proceed with reporting
                the vendor with the "Report" button below
              </Typography>
              <Box className="mt-5 flex justify-evenly">
                <Button
                  variant="contained"
                  color="success"
                  onClick={MessageRemainder}
                  disabled={isLoading}
                >
                  Send Text Message Remainder
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={ReportOther}
                  disabled={isLoading}
                >
                  Report Other Party
                </Button>
              </Box>
            </Box>
          ) : (
            <Box>
              <Box className="text-center mt-3">
                {msg?.zoomStatus === 0 && (
                  <Typography variant="h5" className="mb-4">
                    No Calls Scheduled
                  </Typography>
                )}
                {msg?.zoomStatus === 1 && (
                  <>
                    {msg?.zoomRole === user.UserID ? (
                      <Typography variant="h5" className="mb-4">
                        Call Request Sent for {response.protimelast} {proZone}{" "}
                        for 30 mins
                      </Typography>
                    ) : (
                      <Typography variant="h5" className="mb-4">
                        Call Requested for{" "}
                        {user.RoleId !== 1
                          ? response.custtimelast
                          : response.protimelast}{" "}
                        {user.RoleId !== 1 ? custZoneName : proZone} for 30 mins
                      </Typography>
                    )}
                  </>
                )}
                {msg?.zoomStatus === 2 && (
                  <Typography variant="h5" className="mb-4">
                    Call rejected
                  </Typography>
                )}
                {msg?.zoomStatus === 3 && (
                  <>
                    {msg?.zoomRole === user?.UserID ? (
                      <Typography variant="h5" className="mb-4">
                        Call Scheduled for {response.protimelast}{" "}
                        {msg?.zoomRole !== msg?.createdBy
                          ? custZoneName
                          : proZone}{" "}
                        for 30 mins
                      </Typography>
                    ) : user.RoleId !== 1 ? (
                      <Typography variant="h5" className="mb-4">
                        Call Scheduled for {response.custtimelast}{" "}
                        {msg?.zoomRole !== msg?.createdBy
                          ? proZone
                          : custZoneName}{" "}
                        for 30 mins
                      </Typography>
                    ) : (
                      <Typography variant="h5" className="mb-4">
                        Call Scheduled for {response.protimelast}{" "}
                        {msg?.zoomRole !== msg?.createdBy
                          ? custZoneName
                          : proZone}{" "}
                        for 30 mins
                      </Typography>
                    )}
                  </>
                )}
                {msg?.zoomStatus === 4 && (
                  <>
                    {msg?.updatedBy === msg?.zoomRole ? (
                      <Typography variant="h5" className="mb-4">
                        Rescheduled To{" "}
                        {msg?.zoomRole === user?.UserID
                          ? response.protimelast
                          : response.custtimelast}{" "}
                        {user && user.UserID === msg?.createdBy
                          ? proZone
                          : user?.UserID === 1
                          ? proZone
                          : custZoneName}{" "}
                        for 30 mins
                      </Typography>
                    ) : (
                      <Typography variant="h5" className="mb-4">
                        Rescheduled To{" "}
                        {msg?.zoomRole !== user?.UserID
                          ? response.protimelast
                          : response.custtimelast}{" "}
                        {user && user.UserID !== 4
                          ? proZone
                          : user?.UserID === 1
                          ? proZone
                          : custZoneName}{" "}
                        for 30 mins
                      </Typography>
                    )}
                  </>
                )}
                {msg?.zoomStatus === 5 && (
                  <Typography variant="h5" className="mb-4">
                    Both or either parties not joined the call
                  </Typography>
                )}
                {msg?.zoomStatus === 6 && (
                  <Typography variant="h5" className="mb-4">
                    Call completed
                  </Typography>
                )}
                {msg?.zoomStatus === 7 && (
                  <Typography variant="h5" className="mb-4">
                    Call Cancelled
                  </Typography>
                )}
              </Box>
              <Box>
                {msg?.zoomStatus === 3 && user.RoleId !== 1 && (
                  <Typography className="mx-4 text-sm">
                    <strong>Note:</strong> The "Start Call" button is enabled 5
                    minutes before the scheduled call time
                  </Typography>
                )}
              </Box>
              <Box className="d-flex justify-content-end mt-1 gap-2 flex-wrap">
                {user.UserID !== msg?.zoomRole &&
                  (msg?.zoomStatus === 1 || msg?.zoomStatus === 4) && (
                    <>
                      {!isPast && (
                        <>
                          <Button
                            variant="outlined"
                            color="success"
                            onClick={AcceptZoomCall}
                            disabled={isLoading}
                          >
                            Accept
                          </Button>
                          <Button
                            variant="outlined"
                            color="error"
                            onClick={RejectZoomCall}
                            disabled={isLoading}
                          >
                            Reject
                          </Button>
                        </>
                      )}
                    </>
                  )}
                {msg?.zoomStatus !== 0 && user.RoleId !== 1 && (
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => {
                      setReSchedule(true);
                      setMissedCall(false);
                    }}
                    className="text-nowrap"
                  >
                    {msg?.zoomStatus === 2 ||
                    msg?.zoomStatus === 5 ||
                    msg?.zoomStatus === 6 ||
                    msg?.zoomStatus === 7
                      ? "Schedule Again"
                      : "Request Reschedule"}
                  </Button>
                )}
                {msg?.zoomStatus === 3 && (
                  <>
                    <Button
                      variant="contained"
                      color="error"
                      onClick={CallCancel}
                      className="text-nowrap"
                    >
                      Cancel Call
                    </Button>
                    <Button
                      variant="contained"
                      color="success"
                      onClick={CallLaunch}
                      disabled={isCallDisabled}
                      className="text-nowrap"
                    >
                      Start Call
                    </Button>
                  </>
                )}
              </Box>
              {!missedCall &&
                !reSchedule &&
                user.RoleId !== 1 &&
                !isCallDisabled &&
                (msg.zoomStatus === 3 || msg.zoomStatus === 5) && (
                  <Box className="text-end mt-2">
                    <Typography
                      component="a"
                      onClick={handleClick}
                      sx={{ cursor: "pointer", textDecoration: "underline" }}
                    >
                      Report Missed Call
                    </Typography>
                  </Box>
                )}
              {/* {user.RoleId !== 1 && !isPast && !missedCall && (
                <Typography className="text-red-500 text-sm mt-3 text-end">
                  <strong>
                    Warning: Your communication score will be negatively
                    affected if you reschedule.
                  </strong>
                </Typography>
              )} */}
              <Warning></Warning>
            </Box>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CallDetailsModal;
